export const translateMovementTypes = {
  SHOPPING: 'Compra',
  CASHBACK: 'Cashback',
  BONUS: 'Bonificação',
  EXPIRATION_POINTS: 'Expiração',
  REDEEM_POINTS: 'Resgate de pontos',
  REDEEM_FACTORY_VISIT: 'Resgate Visita à Fábrica',
  REDEEM_EXCLUSIVE_EVENT: 'Resgate Evento Exclusivo',
  REVERSAL_POINTS: 'Estorno',
  MANUAL_ADJUSTMENT: 'Ajuste manual',
  CONTRACT_CANCELLATION: 'Cancelamento de contrato',
  PURCHASE_CANCELLED: 'Compra Cancelada',
  BIRTHDAY_CAMPAIGN: 'Campanha de Aniversário',
  MISSION_ACCOMPLISHED: 'Desafio Concluído',
  BENEFIT_USE: 'Resgate de Benefício',
  ACCELERATOR: 'Bônus Acelerador',
  OPTOUT: 'Descadastramento do programa beautybox'
}
